import { render, staticRenderFns } from "./DefaultHero.vue?vue&type=template&id=f6b5b844&scoped=true&"
import script from "./DefaultHero.vue?vue&type=script&lang=js&"
export * from "./DefaultHero.vue?vue&type=script&lang=js&"
import style0 from "./DefaultHero.vue?vue&type=style&index=0&id=f6b5b844&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b5b844",
  null
  
)

export default component.exports